import dotProp from "dot-prop";
import { getAge } from "../birthday_to_age.js";
import addressSchema from "./addressSchema";

const contactSchema = function (state, props, isPatient) {
  const phoneMask = (rawValue) => {
    if(rawValue.replace(/[\s_+]/g,'').length <= 10) {
      return ['+', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ',  /\d/, /\d/]
    } else {
      return ['+', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ',/\d/, /\d/, ' ', /\d/, /\d/]
    }
  }


  let birthdayLabel = I18n.t('api.forms.contact.birthday')
  if (isPatient) {
    const contactId = dotProp.get(state, `entities.dossier.byId.${props.entityId}.patientId`)
    const birthdayString = dotProp.get(state, `entities.contact.byId.${contactId}.birthday`)
    if (birthdayString) {
      const age = getAge(birthdayString)
      birthdayLabel = birthdayLabel.concat(' ', I18n.t('api.forms.contact.age_descriptor', {age: age}))
    }
  }

  return {
    "ui:readonly": props.readonly,
    "firstName": {
      "ui:group": 'name',
      "ui:options": {
        width: 6
      }
    },
    "lastName": {
      "ui:group": 'name',
      "ui:options": {
        width: 6
      }
    },
    "email": {
      "ui:group": 'email',
      "ui:options": {
        width: 6
      }
    },
    "birthday": {
      "ui:widget": "BirthdayWidget",
      "ui:group": 'email',
      "ui:label":birthdayLabel,
      "ui:options": {
        width: 4
      }
    },
    "securityNumber": {
      "ui:group": 'phone',
      "ui:autofocus": true,
      "ui:emptyValue": "",
      "ui:placeholder": "",
      "ui:widget": isPatient? "MaskedTextWidget" : "hidden",
      "ui:options" : {
        mask: [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, '-', /\d/, /\d/, /\d/, '.', /\d/, /\d/],
        copyButton: true,
        charsNotToCopy: ['.', '-', '_'],
        width : 4
      }
    },
    "gender": {
      "ui:widget": "hidden",
    },
    "startTime": {
      "ui:widget": "hidden",
    },
    "endTime": {
      "ui:widget": "hidden",
    },
    "phone": {
      "ui:group": 'phone',
      "ui:options": {
        width: 4
      }
    },
    ...addressSchema(state,props)
  }

}

export default contactSchema;
